import React from 'react'
import ProdIOTRetMatRow from './ProdIOTRetMatRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";
import { UiView, UiViewContent } from "../../../../../library/layout/Index";
import * as fn from "../../../../../helper/uiFunctions";

const ProdIOTRetMat = (props) => {
    const { formObject, viewData } = props;

    const rowSelector = useRowSelector("2", null);

    const renderItemToReturn = (row, index) => {
        if (fn.compareNumber(row.rowValues.isAlreadyRet.val, 0)) {
            return (
                <li><ProdIOTRetMatRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={index + 1} /></li>
            )
        }
        else {
            return(null);
        }
    }

    const renderItemToReturnMore = (row, index) => {
        if (fn.compareNumber(row.rowValues.isAlreadyRet.val, 1)) {
            return (
                <li><ProdIOTRetMatRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={index + 1} /></li>
            )
        }
        else {
            return(null);
        }
    }


    return (
        <UiView>
            <UiViewContent>
                <ul className="uiListTable">
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                action={{ paramName: "variation1Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                action={{ paramName: "variation2Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                            </FormWrapper>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Qty Issued" /></li>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty Return" /></li>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty Consume" /></li>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty Wastage" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            renderItemToReturn(row, index)
                        ))
                    }
                </ul>
            </UiViewContent>
            <UiViewContent>
                <ul className="uiListTable uiSpacer20" style={{display:"none"}}>
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                            <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                action={{ paramName: "variation1Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn50" headerKey="viewConfig"
                                action={{ paramName: "variation2Name" }} >
                                <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                            </FormWrapper>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty Returned" /></li>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty Consumed" /></li>
                            <li className="uiColumnCenter uiColumn130"><SarasTrans value="Qty Wasted" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            renderItemToReturnMore(row, index)
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdIOTRetMat, "prodIOTRetMat", "");